import { Box, Step, StepIndicator, Typography } from '@mui/joy';
import { Check } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { NotificationProvider } from 'core/states';
import { useInnerStepsContext } from 'core/states/innerSteps';
import { Color, Level, Orientation, Variant } from 'theme/enums';

import { LeftWrapper, RightWrapper, Stepper, Wrapper } from './style';

const getStepColor = (completed: boolean, disabled: boolean) => {
  if (completed) {
    return Color.SUCCESS;
  }

  if (disabled) {
    return Color.NEUTRAL;
  }

  return Color.PRIMARY;
};

const getStepVariant = (completed: boolean, disabled: boolean, active: boolean) => {
  if (completed || active) {
    return Variant.SOLID;
  }

  if (disabled) {
    return Variant.SOFT;
  }

  return Variant.OUTLINED;
};

const InnerSteps = () => {
  const { t } = useTranslation();
  const { steps, activeStep, activeStepIndex } = useInnerStepsContext();

  return (
    <NotificationProvider>
      <Wrapper container>
        <LeftWrapper xs={2} md={3}>
          <Stepper orientation={Orientation.VERTICAL}>
            {steps.map((step, index) => {
              const completed = step.completed || activeStepIndex > index;
              const disabled = step.disabled;
              const active = step.type === activeStep.type;

              return (
                <Step
                  key={step.type}
                  completed={completed}
                  active={active}
                  disabled={disabled}
                  indicator={
                    <StepIndicator
                      variant={getStepVariant(completed, disabled, active)}
                      color={getStepColor(completed, disabled)}
                    >
                      {completed ? <Check /> : index + 1}
                    </StepIndicator>
                  }
                >
                  <Box>
                    {step.title}

                    <Typography
                      level={Level.TITLE_SM}
                      color={completed ? Color.SUCCESS : Color.NEUTRAL}
                      sx={{ position: 'absolute' }}
                    >
                      {completed ? t('labelDone') : step?.subtitle}
                    </Typography>
                  </Box>
                </Step>
              );
            })}
          </Stepper>
        </LeftWrapper>
        <RightWrapper xs={10} md={9}>
          {activeStep.content}
        </RightWrapper>
      </Wrapper>
    </NotificationProvider>
  );
};

export default InnerSteps;
